import React from "react";
export const MarkdownContentContext = React.createContext({
    content: "",
    isStreaming: false,
    isLastMessage: false,
});
//# sourceMappingURL=MarkdownContentContext.js.map